export const PatientProfilesAssistant = {
    "Patient Profile": {
        items: [
            //Customising patient profile fields
            {
                heading: 'Customising patient profile fields',
                permissions: ['System Admin'],
                tags: ['profile', 'create', 'custom', 'setup'],
                sections: [
                    {
                        description: 'Navigate to the patient profile setup',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the patient profile setup',
                        action: {
                            type: 'location',
                            value: '/sys-admin/patient',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}